import { useNavigate, useParams } from "react-router-dom";
import { getNavigationUrl } from "../../store/navigationUtil";
import { useEffect } from "react";
import { loadClip } from "./utils/dataLoader";

// Will auto forward to a clip to the correct page based on clip state, to be used as a safe location to navigate from any workflow
export default function ClipNavigator() {
  const { caseId, clipId } = useParams();
  const navigate = useNavigate();

  if (!caseId || !clipId) {
    navigate(getNavigationUrl());
  }

  const load = async () => {
    const currentClip = await loadClip(caseId, clipId);
    if (!currentClip) {
      navigate(getNavigationUrl());
    }
    const url = getNavigationUrl(caseId, currentClip);
    console.log(`[Navigation] to ${url}`);
    navigate(url, { replace: true });
  };

  useEffect(() => {
    load();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
